import FullScreenLoader from "components/FullScreenLoader"
import AuthLayout from "layout/AuthLayout"
import { observer } from "mobx-react-lite"
import React, { useContext, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { BASE_URL } from "services"
import useSWR from "swr"
import AppFee from "../AppFee"
import LoanComp from "../LoanComp"
import { DASHBOARD_APPLY_UNDERGRAD_ROUTE, DASHBOARD_NEXTOFKINROUTE, DASHBOARD_PAYMENT_DETAILS_ROUTE, DASHBOARD_PROFILEROUTE } from "routes"
import http from "services/httpService"
import GuarantorForm from "../GuarantorForm"
import GuarantorFormTwo from "../GuarantorFormTwo"
import { onBoardStep } from "routes/apirRoutes"
import toast from "react-hot-toast"
import { checkOnBoarding } from "services/MiscService"
import { UndergraduateLoanStepContext } from "context/LoanStepContext"
import InstitutionInfoPage from "../InstitutionInfoPage"
import StepsHeader from "./StepsHeader"
import LoanDetailReview from "../LoanReview/LoanDetailReview"
import UndergraduateUpload from "./UndergraduateUpload"

const UnderGraduateLoan = () => {
	const {step,loading} =  useContext(UndergraduateLoanStepContext)
	const navigate = useNavigate()
	let params = useParams()
	const url = `${BASE_URL}/loans/${params?.id}`

	const fetcher = async (apiURL) => {
		const res = await http.get(apiURL)
		return res?.data?.data
	}
	const { data: loan, mutate,} = useSWR(url, fetcher)


	useEffect( ()=>{
		const handleOnBoarded = async () => {
			const info = await checkOnBoarding();
			if(info?.error) {
				toast.error(info.error);
				return;
			}
			// reroute to onboarding page
			if(!info.onBoarded && info.nextStep === onBoardStep.profile){
				navigate(DASHBOARD_PROFILEROUTE)
				return;
			}
			if(!info.onBoarded && info.nextStep === onBoardStep.next_of_kin){
				navigate(DASHBOARD_NEXTOFKINROUTE)
				return;
			}
			if(!info.onBoarded && info.nextStep === onBoardStep.bank_account){
				navigate(DASHBOARD_PAYMENT_DETAILS_ROUTE)
				return;
			}
		  }
		handleOnBoarded();
	},[navigate]);

	const loanForms = [
		<InstitutionInfoPage loanType={"undergraduate"} mutate={mutate} />,
		<LoanComp id={params?.id} mutate={mutate} loanType={"undergraduate"} />,
		<GuarantorForm id={params?.id} mutate={mutate} loanType={"undergraduate"} />,
		<GuarantorFormTwo id={params?.id} mutate={mutate} loanType={"undergraduate"} />,
		<UndergraduateUpload mutate={mutate} id={params?.id} />,
		<LoanDetailReview/>,
		<AppFee id={params?.id} mutate={mutate} />
	]

	if (loading) return <FullScreenLoader show={true} />
	if (params?.id && loan && loan.length <= 0) {
		navigate(`${DASHBOARD_APPLY_UNDERGRAD_ROUTE}`)
	}
	return (
		<AuthLayout>
			<>
			<StepsHeader/>
				{loanForms[step]}
			</>
		</AuthLayout>
	)
}

export default observer(UnderGraduateLoan)
